export default "__VITE_PUBLIC_ASSET__080d4aef__"